import api from "lib/api";

export const login = async (params = {}) => {
  return await api.post(`/v1/auth/signin`, params);
};
export const loginByAdmin = async (params = {}) => {
  return await api.post(`/v1/admin/signinForAdmin`, params);
};

